import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Code } from '@/types/logs'

const GET_DISRUPTION_TYPES_KEY = 'GET_DISRUPTION_TYPES'

export const useGetDisruptionTypes = () =>
    useAppQuery<Code[]>({
        queryKey: [GET_DISRUPTION_TYPES_KEY],
        queryFn: () =>
            createInstance({
                url: '/codes',
                params: {
                    CodeId: 'DIS',
                },
                method: 'GET',
            }),
        staleTime: Infinity,
    })
